export const GAME_STATUS_REQUEST = 'GAME_STATUS_REQUEST';
export const GAME_STATUS_SUCCESS = 'GAME_STATUS_SUCCESS';
export const GAME_DOWNLOAD_VALUABLE_REQUEST = 'GAME_DOWNLOAD_VALUABLE_REQUEST';
